"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useReactiveReactiveListProps = void 0;

var react_1 = __importDefault(require("react"));

var hooks_1 = require("../../hooks");

var useReactiveReactProp_1 = require("./useReactiveReactProp");

var useReactiveReactiveListProps = function useReactiveReactiveListProps(options) {
  var _ref = (0, hooks_1.useFilters)(),
      filterStack = _ref.filterStack;

  var reactiveReactProp = (0, useReactiveReactProp_1.useReactiveReactProp)();
  var context = (0, hooks_1.useReactifySearchContext)();
  var _context$options = context.options,
      includeFields = _context$options.includeFields,
      excludeFields = _context$options.excludeFields;
  var size = react_1.default.useMemo(function () {
    var _a, _b;

    return (_b = (_a = options.pageSize) !== null && _a !== void 0 ? _a : filterStack === null || filterStack === void 0 ? void 0 : filterStack.pageSize) !== null && _b !== void 0 ? _b : 20;
  }, [options.pageSize, filterStack]);
  var reactiveReactiveListProps = react_1.default.useMemo(function () {
    return {
      size: size,
      URLParams: true,
      showLoader: false,
      dataField: "title",
      showResultStats: false,
      react: reactiveReactProp,
      includeFields: includeFields,
      excludeFields: excludeFields,
      scrollTarget: options.scrollTarget,
      componentId: "page",
      scrollOnChange: false,
      pagination: (filterStack === null || filterStack === void 0 ? void 0 : filterStack.paginationType) !== "infinite_scroll",
      infiniteScroll: (filterStack === null || filterStack === void 0 ? void 0 : filterStack.paginationType) === "infinite_scroll",
      renderNoResults: function renderNoResults() {
        return null;
      } // always use only render, otherwise both are shown

    };
  }, [filterStack, reactiveReactProp, options.pageSize]);
  return reactiveReactiveListProps;
};

exports.useReactiveReactiveListProps = useReactiveReactiveListProps;